import React, { Component } from "react";

import { Table, Card, Row, Col, Form, Image, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { appConfig } from "../../../config";

import ModalImage from "react-modal-image";
import ChemistInvoiceView from "../ChemistInvoice/ChemistInvoiceView";
import ChemistInvoiceStatusChange from "../ChemistInvoice/ChemistInvoiceStatusChange";

import "../../Common/Common.css";
var dateFormat = require("dateformat");

class ChemistInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ChemistInvoiceShow: false,
      showChemistInvoiceActive: false,
      searchChemistInvoice: "",
      filterValue: "",
      page: 0,
      perPage: 10,
    };
  }

  componentDidMount() {
    this.props.chemistInvoiceList({
      page: undefined,
      search: this.state.searchChemistInvoice,
      filter: this.state.filterValue,
    });
  }

  //For search
  SearchOnChange = (event) => {
    this.setState(
      {
        searchChemistInvoice: event.target.value,
        page: 0,
        filterValue: "",
      },
      () => {
        this.props.chemistInvoiceList({
          page: undefined,
          search: this.state.searchChemistInvoice,
          filter: this.state.filterValue,
        });
      }
    );
  };

  //For filter
  handleChange = (event) => {
    this.setState(
      {
        filterValue: event.target.value,
        searchChemistInvoice: "",
        page: 0,
      },
      () => {
        this.props.chemistInvoiceList({
          page: undefined,
          search: this.state.searchChemistInvoice,
          filter: this.state.filterValue,
        });
      }
    );
  };

  //View invoice detail
  handleChemistInvoiceView = (item) => {
    this.setState({
      ChemistInvoiceShow: true,
      ChemistInvoiceDtls: item,
    });
  };

  handleCloseChemistInvoiceView = () => {
    this.setState({ ChemistInvoiceShow: false });
  };

  //For status change
  handleChemistInvoiceActiveView = (item) => {
    this.setState({
      showChemistInvoiceActive: true,
      ChemistInvoiceActiveDtls: item,
    });
  };

  handleCloseActive = () => {
    this.setState({ showChemistInvoiceActive: false });
  };

  //For pagination
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ChemistInvoiceSelectedPage({
      page: selectedPage + 1,
      search: this.state.searchChemistInvoice,
      filter: this.state.filterValue,
    });
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  render() {
    console.log(this.props.chemistInvoiceDtlsList);
    //Destructuring
    const {
      page,
      perPage,
      searchChemistInvoice,
      filterValue,
      ChemistInvoiceShow,
      ChemistInvoiceDtls,
      showChemistInvoiceActive,
      ChemistInvoiceActiveDtls,
    } = this.state;
    const { chemistInvoiceDtlsCount, chemistInvoiceDtlsList, statusChange } =
      this.props;
    const {
      SearchOnChange,
      handleChange,
      handleChemistInvoiceView,
      handleCloseChemistInvoiceView,
      handleChemistInvoiceActiveView,
      handleCloseActive,
      resetPage,
      handlePageClick,
    } = this;

    let p = page + 1;
    const count = chemistInvoiceDtlsCount && chemistInvoiceDtlsCount;
    let ChemistInvoicePageCount = Math.ceil(count / perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Chemist Invoices</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={filterValue}
                    onChange={handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="open">Open</option>
                    {/* <option value="partial">Partial</option> */}
                    <option value="paid">Paid</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon" />
                    <input
                      type="text"
                      placeholder="Reference No/Order ID"
                      value={searchChemistInvoice}
                      onChange={SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon" />
                  <span className="cmnPageCount">
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>REFERENCE NO</th>
                    <th>ORDER ID</th>
                    <th>CHEMIST</th>
                    <th>DISTRIBUTOR</th>
                    <th>AMOUNT</th>
                    {/* <th>ORDER TYPE</th> */}
                    <th>STATUS</th>
                    {/* <th>VIEW INVOICE</th> */}
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {chemistInvoiceDtlsList &&
                    chemistInvoiceDtlsList.map((item, i) => (
                      <tr key={i}>
                        <td>{10 * (p - 1) + i + 1}</td>
                        <td>{item && item.invNo}</td>
                        <td>{item && item.orderId && item.orderId.orderNo}</td>
                        <td className="cmn_Cap">
                          {item && item.chmstDtls && item.chmstDtls.name}
                        </td>
                        <td className="cmn_Cap">
                          {item && item.dstbtrDtls && item.dstbtrDtls.name}
                        </td>
                        <td className="rightAlign">{item && item.amount}</td>
                        {/* <td className="cmn_Cap">{item && item.orderType}</td> */}
                        <td className="cmn_Cap">{item && item.status}</td>
                        {/* <td>{item&&item.imgUrl?
                        (<ModalImage 
                          small={item&&item.imgUrl&&(appConfig.imgServerip+`/getInvImg?imgName=${item.imgUrl}`)}
                          large={item&&item.imgUrl&&(appConfig.imgServerip+`/getInvImg?imgName=${item.imgUrl}`)}
                          hideDownload={true} hideZoom={true} className="imageModalClass"
                        />):"No attachments"}
                      </td> */}
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg"
                              onClick={() =>
                                handleChemistInvoiceView({ item: item })
                              }
                            />

                            <i
                              className="fa fa-ban fa-lg"
                              style={{ paddingLeft: 10 }}
                              onClick={() =>
                                handleChemistInvoiceActiveView({ item: item })
                              }
                            />
                            <ChemistInvoiceStatusChange
                              show={showChemistInvoiceActive}
                              handleClose={handleCloseActive}
                              ChemistInvoiceActiveDtls={
                                ChemistInvoiceActiveDtls
                              }
                              ChemistInvoiceStatusChange={statusChange}
                              resetPage={resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <ChemistInvoiceView
                show={ChemistInvoiceShow}
                handleClose={handleCloseChemistInvoiceView}
                ChemistInvoiceDtls={ChemistInvoiceDtls}
              />
              {(chemistInvoiceDtlsList === undefined ||
                (chemistInvoiceDtlsList && chemistInvoiceDtlsCount === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../../src/assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No invoices found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {ChemistInvoicePageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={ChemistInvoicePageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default ChemistInvoice;
